import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Load user from localStorage
const storedUser = JSON.parse(localStorage.getItem('user'));

const initialState = {
  user: storedUser || null,
  isLoggedIn: !!storedUser,
  isLoading: false,
  otpSent: false,
  error: '',
};

// Send OTP thunk
export const sendOtp = createAsyncThunk('auth/sendOtp', async (mobile) => {
  const res = await axios.post('https//api.monkeybox.ai/api/auth/send-otp', {
    mobileno: mobile,
  });
  return res.data;
});

// Verify OTP thunk
export const verifyOtp = createAsyncThunk('auth/verifyOtp', async ({ mobile, otp }) => {
  const res = await axios.post('https//api.monkeybox.ai/api/auth/verify-otp', {
    mobileno: mobile,
    otp,
  });
  return res.data.user;
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.isLoggedIn = false;
      state.otpSent = false;
      localStorage.removeItem('user'); // ✅ clear persisted user
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.isLoading = true;
        state.error = '';
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.isLoading = false;
        state.otpSent = true;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
        state.error = '';
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.isLoggedIn = true;

        // ✅ persist to localStorage
        localStorage.setItem('user', JSON.stringify(action.payload));
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isLoggedIn = false;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
